const themeControllerInputs = document.querySelectorAll<HTMLInputElement>('.theme-controller');

themeControllerInputs.forEach((input) => {
  input.addEventListener('change', () => {
    if (input.checked) {
      localStorage.setItem('theme', 'atomusdark');
    } else {
      localStorage.setItem('theme', 'atomusligth');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const theme = localStorage.getItem('theme');
  if (theme === 'atomusdark') {
    themeControllerInputs.forEach((input) => {
      input.checked = true;
    });
  }
});
